'use client';
import { FC, ReactNode } from 'react';

import { useDisableStore } from 'state/disableStore';

export const ExperienceEnabled: FC<{ children: ReactNode }> = props => {
  const isExperienceDisabled = useDisableStore(
    store => store.isExperienceDisabled
  );

  return isExperienceDisabled ? null : props.children;
};
